import React from "react";
import "./demoVideo.css";
const DemoVideo = () => {
  return (
    <div
      id="packages"
      className="demo"
     
    >
      <div className="demo__container">
        <h3 className="demo__title">Watch Our Demo</h3>
        <div className="video-wrapp">
        <iframe
          width="930"
          height="530"
          src="https://www.youtube.com/embed/Wkjutx8MMwI?si=3EwpToQQJ-FugpIC&amp;controls=0"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe></div>
      </div>
    </div>
  );
};

export default DemoVideo;
